import React, { useEffect } from "react";
import exploreHealthcare from "../../../main/assets/images/Images/Healthcare/Explore-Healthcare-Future-bg.png";
import healthcare_img_4 from "../../../main/assets/images/Images/Healthcare/healthcare_img_4.png";
import healthcareBanner from "../../../main/assets/images/Images/Healthcare/Healthcare-banner.png";
import Healthcarebannermobile from "../../../main/assets/images/Images/Healthcare/Healthcare_banner_mobile.png";
import healthcare_benefit_1 from "../../../main/assets/images/Images/Healthcare/healthcare_benefit_1.png";
import healthcare_benefit_2 from "../../../main/assets/images/Images/Healthcare/healthcare_benefit_2.png";
import healthcare_benefit_3 from "../../../main/assets/images/Images/Healthcare/healthcare_benefit_3.png";
import healthcare_benefit_4 from "../../../main/assets/images/Images/Healthcare/healthcare_benefit_4.png";
import hospitalBed from "../../../main/assets/images/Images/Healthcare/hospital-bed-allocation.png";
import remotePatient from "../../../main/assets/images/Images/Healthcare/remote-patient-monitoring.png";
import vaccineDistribution from "../../../main/assets/images/Images/Healthcare/vaccine-distribution.png";
import enhancedPatient from "../../../main/assets/images/Icons/Healthcare/enhanced.png";
import futureProofing from "../../../main/assets/images/Icons/Healthcare/future.png";
import operationalExcellence from "../../../main/assets/images/Icons/Healthcare/operational.png";
import patientFlow from "../../../main/assets/images/Icons/Healthcare/patient.png";
import predictivePatient from "../../../main/assets/images/Icons/Healthcare/health.svg";
import predictivepatient1 from "../../../main/assets/images/Icons/Healthcare/predictive-patient.svg";
import Group2 from "../../../main/assets/images/Icons/Healthcare/Group2.png";
import Group3 from "../../../main/assets/images/Icons/Healthcare/Group3.png";
import Group4 from "../../../main/assets/images/Icons/Healthcare/Group4.png";
import scenarioModelling from "../../../main/assets/images/Icons/Healthcare/modeling.png";
import strategicDecision from "../../../main/assets/images/Icons/Healthcare/strategic.png";
import Layer_1 from "../../../main/assets/images/Icons/Healthcare/supply-chain.svg";
import { Button } from "main/components/ui-components/Button";
import { MainPageHeader, SectionCard } from "main/components";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import SectionCardMobile from "main/components/componentsHelper/whtyantrapage/SectionCardMobile";

const featureHealthcare = [
  {
    image: predictivePatient,
    whiteIcon: predictivepatient1,
    title: "Predictive Patient Care",
    subTitle:
      "Anticipate patient needs using AI-driven insights to tailor care plans.",
  },
  {
    image: Layer_1,
    whiteIcon: Group2,
    title: "Supply Chain Management",
    subTitle:
      "Ensure timely availability of critical medical supplies and equipment.",
  },
  {
    image: scenarioModelling,
    whiteIcon: Group3,
    title: "Scenario Modelling",
    subTitle:
      "Simulate and prepare for various patient influx scenarios, ensuring readiness for any health crisis.",
  },
  {
    image: patientFlow,
    whiteIcon: Group4,
    title: "Patient Flow Optimization",
    subTitle:
      "Streamline patient journeys from admission to discharge, enhancing experiences and resource allocation.",
  },
];

const realWorldUseCases = [
  {
    image: hospitalBed,
    title: "Hospital Bed Allocation",
    subTitle:
      "Predict patient admissions, optimising bed allocations and reducing patient wait times.",
  },
  {
    image: vaccineDistribution,
    title: "Vaccine Distribution",
    subTitle:
      "Forecast vaccine demands, ensuring efficient and widespread distribution.",
  },
  {
    image: remotePatient,
    title: "Remote Patient Monitoring",
    subTitle:
      "A telehealth platform integrated Yantr.ai to predict potential health deteriorations in real-time, enabling timely interventions.",
  },
];

const benefits = [
  {
    image: enhancedPatient,
    mobileImage: healthcare_benefit_1,
    title: "Enhanced Patient Care",
    subTitle:
      "Predict patient admissions, optimising bed allocations and reducing patient wait times.",
  },
  {
    image: operationalExcellence,
    mobileImage: healthcare_benefit_2,
    title: "Operational Excellence",
    subTitle:
      "Optimise patient care processes for efficiency and satisfaction, from admissions to supply chain management.",
  },
  {
    image: strategicDecision,
    mobileImage: healthcare_benefit_3,
    title: "Strategic Decision Making",
    subTitle:
      "Equip healthcare leaders with actionable insights to drive informed strategic decisions.",
  },
  {
    image: futureProofing,
    mobileImage: healthcare_benefit_4,
    title: "Future-Proofing",
    subTitle:
      "Stay ahead of healthcare trends and challenges by leveraging real-time analytics and predictions.",
  },
];

export default function Healthcare() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section>
        <MainPageHeader
          backgroundImage={healthcareBanner}
          mobilebgImage={Healthcarebannermobile}
          HeaderClassName="text-color-success"
          heading={"Healthcare"}
          descriptionClass="text-color-success mb-3"
          description={`The healthcare industry is on the cusp of a technological revolution, and Yantr.ai is at the forefront of this transformation.`}
          buttonGroup={
            <>
              <div className="d-block d-md-none">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                    className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Book a Demo"
                  />
                </Link>
              </div>
              <div className="d-none d-md-block">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                    className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Book a Demo"
                  />
                </Link>
              </div>
            </>
          }
        />
      </section>
      <div className="container-fluid d-block  d-md-none">
        {/* mobile */}
        <section className="container-fluid  py-40 d-flex flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 mb-25 px-12 font-family-roboto text-align-center para-heading">
            Features Tailored for Healthcare
          </p>

          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper customSwiper"
          >
            {featureHealthcare.map((val, index) => (
              <SwiperSlide className="p-10">
                <div className="col-md-12 col-sm-12 col-lg-12">
                  <Col key={index}>
                    <SectionCardMobile
                      classname="cards"
                      title={val.title}
                      icon={val.image}
                      whiteIcon={val.whiteIcon}
                      desc={val.subTitle}
                    />
                  </Col>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </div>
      <div className="container d-none d-md-block">
        {" "}
        {/* website */}
        <section className="container pt-60 pb-50 d-flex flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 mb-25 font-family-roboto text-align-center para-heading">
            Features Tailored for Healthcare
          </p>
          <div className="row cardsection px-mob-140">
            {featureHealthcare.map((item: any, index: any) => {
              return (
                <div className="col-md-6 col-sm-12 col-lg-3 p-10">
                  <div className="" key={index}>
                    <div
                      className={`tcard-container d-flex flex-column py-20 radius-10 justify-content-center border border-1`}
                    >
                      <div className="image-container">
                        <img
                          className="tfront-image mx-5 my-3 mt-5"
                          src={item?.image}
                          alt="background will be here"
                        />
                        <img
                          className="tback-image mx-5 my-3"
                          src={item?.whiteIcon}
                          alt="background will be here"
                        />
                      </div>
                      <div className="card-body">
                        <p
                          className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-24 line-26 pb-2`}
                          style={{ color: "#3D1187" }}
                        >
                          {item?.title}
                        </p>
                        <p
                          className="px-3 tcard-desc text-center text-white-color fonts-400 font-18 line-20 font-family-roboto"
                          style={{ color: "#3D1187" }}
                        >
                          {item?.subTitle}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
      <section className="py-60 footer d-flex font-family-roboto flex-column align-items-center">
        <p className="text-white-color fonts-800 font-30 mb-50 text-align-center line-35 font-family-roboto realworld">
          Real World Use Cases
        </p>

        <div className="row w-85 flex-gap-20 justify-content-between">
          {realWorldUseCases.map((item: any, index: any) => {
            return (
              <div
                key={index}
                className="real-world-view card-container1 flex-column w-30 mobile-cards-width d-flex px-16"
              >
                <img
                  src={item?.image}
                  className="img-br-8 "
                  alt="background will be here"
                />
                <p className="text-white-color font-family-roboto fonts-800 font-20 line-23 mt-3">
                  {item?.title}
                </p>
                <p className="text-white-color font-family-roboto fonts-400 font-16 line-20 mt-3  footer-subcontent2">
                  {item?.subTitle}
                </p>

                <div className="d-flex align-items-end h-100 mt-20 mb-10">
                  <Link to={"/contact-us"}>
                    <div className="d-none d-md-block">
                      {/* website */}
                      <Button
                        className="py-8 px-4 font-14 line-20 font-family-roboto fonts-500 text-white-color button-purple radius-10"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </div>
                    <div className="d-block d-md-none pt-30">
                      <Button
                        className="py-8 px-4 font-14 line-20 font-family-roboto fonts-500 text-white-color button-purple radius-6"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      {/* mobile */}
      <div className="container-fluid d-block  d-md-none">
        <section className="container-fluid py-40 d-flex font-family-roboto flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 font-family-roboto mb-15 line-35 text-align-center mobile-contactus-heading">
            Benefits
          </p>

          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper customSwiper"
          >
            {benefits.map((item: any, index: any) => (
              <div className="col-md-12 col-sm-12 col-lg-12">
                <div className="col">
                  <SwiperSlide className="p-10">
                    <div
                      key={index}
                      className="cards m-benefits-view flex-column d-flex align-items-center"
                    >
                      <img
                        className="mt-10 w-100 px-10"
                        src={item?.mobileImage}
                        alt="background will be here"
                      />
                      <div className="pt-2 d-flex flex-column align-items-center">
                        <p className="text-black-10 fonts-800 px-10 font-20 font-family-roboto line-24 align-items-center">
                          {item?.title}
                        </p>
                        <p className="px-20 text-grey fonts-400 font-16 mt-2 text-align-center line-20 font-family-roboto footer-subcontent2">
                          {item?.subTitle}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                </div>
              </div>
            ))}
          </Swiper>
        </section>
      </div>
      {/* Website */}
      <div className="d-none d-md-block">
        <section className="container py-60 d-flex font-family-roboto flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 font-family-roboto mb-25 line-35 text-align-center mobile-contactus-heading">
            Benefits
          </p>
          <div className="row justify-content-between px-mob-140">
            {benefits.map((item: any, index: any) => {
              return (
                <div className="col-md-12 col-sm-12 col-lg-6 p-15">
                  <div
                    key={index}
                    className="benefits-view flex-column d-flex align-items-center"
                  >
                    <img
                      src={item?.image}
                      alt="background will be here"
                      className="mt-10 w-100 px-10"
                    />
                    <div className="mt-40 mb-40 d-flex flex-column align-items-center">
                      <p className="text-black-10 fonts-800 font-20 font-family-roboto align-items-center line-24">
                        {item?.title}
                      </p>
                      <p className="px-20 text-grey fonts-400 font-16 mt-2 text-align-center line-20 font-family-roboto">
                        {item?.subTitle}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
      <div className="mx-20">
        <div className="radius-20 footer d-block  d-md-none radius-20">
          {/* mobile */}
          <section
            className="mb-20 py-4 py-md-0 radius-0"
            style={{
              backgroundImage: `url(${healthcare_img_4})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "230px",
            }}
          ></section>
          <div className="footer radius-20 py-0 mb-5 p-3">
            <div className="">
              <p className="text-white-color fonts-800 font-20 line-23 mb-10 pt-20 font-family-condensed">
                Explore Healthcare's Future with Yantr.ai
              </p>
              <p className="text-white-color fonts-400 font-13 font-family-condensed line-15 mb-60">
                Empower your healthcare journey with unparalleled insights and
                optimization solutions. Dive deep into the Yantr.ai healthcare
                revolution.
              </p>
              <div className="pb-40">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                    className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Contact Us"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="container d-none d-md-block">
            {/* Website */}
            <section
              className="mb-60 py-3 py-md-0 radius-20"
              style={{
                backgroundImage: `url(${exploreHealthcare})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              <div className="row py-0 py-md-5">
                <div className="col-lg-6 col-md-12"></div>
                <div className="col-lg-6 col-md-12 px-5">
                  <p className="text-white-color fonts-700 font-32 line-37 mb-10 pt-20 font-family-condensed footer-content">
                    Explore Healthcare's Future with Yantr.ai
                  </p>
                  <p className="text-white-color  font-family-condensed line-23 fonts-400 font-20 mb-20 graph-subheading">
                    Empower your healthcare journey with unparalleled insights
                    and optimization solutions. Dive deep into the Yantr.ai
                    healthcare revolution.
                  </p>
                  <Link to={"/contact-us"}>
                    <Button
                      className="py-12 px-4 font-16 fonts-500 text-white-color font-family-roboto-flex"
                      onClick={() => {}}
                    >
                      Contact Us
                    </Button>
                  </Link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
